import SearchQuestionIcon from 'assets/icons/SearchQuestionIcon';

export default function EmptySearchResult() {
    return (
        <div className="empty-place-holder items-center">
            <div className="flex flex-col items-center">
                <div className="round-div-icon-middle bg-light-blue-200 h-[5rem]	w-[5rem] ">
                    <SearchQuestionIcon />
                </div>
                <p className="text-true-blue w-1/2 text-center mt-8">
                    Looks like we couldn't find any results based on your
                    search. Try a different search term or check our
                    recommendations.
                </p>
            </div>
        </div>
    );
}
